import styled from "styled-components";

export const NavContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding-right: 1rem;

  .tracking-in-expand {
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
    color: var(--color-yellow);
    cursor: pointer;
    position: relative;

    &:hover {
      transition: 0.3s ease-in-out;
      color: var(--color-white);
    }
  }

  @keyframes tracking-in-expand {
    0% {
      letter-spacing: -0.5em;
      opacity: 0;
    }
    40% {
      opacity: 0.6;
    }
    100% {
      opacity: 1;
    }
  }

  @media (min-width: 1024px) {
    flex-direction: row;

    .tracking-in-expand {
      font-size: 20px;
      font-weight: bold;
      text-transform: uppercase;
      color: var(--color-yellow);
      cursor: pointer;

      &:hover {
        transition: 0.3s ease-in-out;
        color: var(--color-white);
      }
    }
    .tracking-in-expand::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 3px;
      bottom: -3px;
      left: 0;
      background-color: var(--color-white);
      visibility: hidden;
      -webkit-transform: scaleX(0);
      transform: scaleX(0);
      -webkit-transition: all 0.3s ease-in-out 0s;
      transition: all 0.3s ease-in-out 0s;
    }

    .tracking-in-expand:hover::before {
      visibility: visible;
      -webkit-transform: scaleX(1);
      transform: scaleX(1);
    }
  }
`;
